import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ResetPage } from './reset.page';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '@app/app-translation.module';
import { PipesModule } from '@shared-pipes/pipes.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ReactiveFormsModule,
		TranslationModule,
		PipesModule,
		RouterModule.forChild([
			{
				path: '',
				component: ResetPage,
			},
		]),
	],
	declarations: [ResetPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResetPageModule {}
